import { RequestConfig } from '@/interface'
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL
const FIELD_PRIFIX = '/common/field/'
const USER_PREIFX = 'adminUser/'
const commonConfig: RequestConfig = {
  // queryFieldConfig 查询自定义字段
  queryFieldConfig: {
    url: `${FIELD_PRIFIX}queryFieldConfig`,
    method: 'post'
  },
  // 查询模块字段列表
  queryListHead: {
    url: `${FIELD_PRIFIX}queryListHead`, // /{labe
    method: 'post'
  },
  // setFieldConfig // 设置自定义字段
  setFieldConfig: {
    url: `${FIELD_PRIFIX}setFieldConfig`,
    method: 'post'
  },
  // setFieldStyle 设置自定义字段样式
  setFieldStyle: {
    url: `${FIELD_PRIFIX}setFieldStyle`,
    method: 'post'
  },
  // 账户密码登录
  login: {
    url: `${LOGIN_URL}login`,
    method: 'post'
  },
  // 授权登录
  authLogin: {
    url: 'wxCp/login',
    method: 'get'
  },
  // 个人详情
  queryLoginUser: {
    url: `${USER_PREIFX}queryLoginUser`,
    method: 'post'
  },
  // 重置密码
  updatePassword: {
    url: `${USER_PREIFX}updatePassword`,
    method: 'post'
  }
}
export default commonConfig
